<template>
  <div class="tab-bar-item" @click="itemClick">
    <div v-if="!isActive"><slot name="item-icon"></slot></div>
    <div v-else><slot name="item-icon-active"></slot></div>
    <div :style="activeStyle"><slot name="item-text"></slot></div>
  </div>
</template>

<script>
export default {
  name: "TabBarItem",
  props: {
    path: {
      type: String,
      default: ''
    }
    ,
    activeColor: {
      type: String,
      default: 'blue'
    }
  },
  data() {
    return {}
  },
  computed: {
    // 判断当前活跃的path是否与item包含path一致
    isActive() {
      return this.$route.path.indexOf(this.path) !== -1
    },
    activeStyle() {
      return this.isActive? {color: this.activeColor} : {}
    }
  },
  methods: {
    // 点击item跳转到路由对应的页面
    itemClick() {
      if (this.$route.path.indexOf(this.path) !== -1) {
        return
      }
      this.$router.replace(this.path)
    },
  },
};
</script>
<style lang="less" scoped>
.tab-bar-item {
  flex: 1;
  // height: 49px;
  font-size: 21px;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #514D4D;
  cursor: pointer;
}

.tab-bar-item img {
  width: 20px;
  height: 20px;
  /* 基线对齐方式 */
  vertical-align: middle;
  margin-bottom: 2px;
  margin-top: -2px;
}

</style>